// --------------------------------------------------------------
// Created On: 2025-10-09
// Author: Zachary Thomas
//
// Last Modified: 2025-11-05
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./AddResourceButton.module.scss";

// Extra wide button with border for adding resources in a modal or on a page.
export default function AddResourceButton(props: Props): Component {
  return (
    <div className={styles.body} data-test="add-resource-button">
      <button
        data-test="add-resource-button"
        className={`${styles.createButton} btn btn-success m-3`}
        type="button"
        onClick={() => props.onAddResource()}
      >
        {props.text}
      </button>
    </div>
  );
}

interface Props {
  text: string;
  onAddResource: () => void;
}
